/* eslint-disable */
import {Filtro} from "../models/filtro/filtro";


export const ProfissionalSCH = (perPage)=> {
    var filtro = new Filtro()
    filtro.perPage = perPage
    filtro.fields = ['*']
    filtro.addOrder('nome', 'desc')
  return filtro
}


export const  getProfissionalSCH = (campo, valor, condicao)=>{
  var filtro = new Filtro()
  filtro.perPage = 1
  filtro.filters.addFilter(campo,valor,condicao)
  return filtro
}

